import { useWidgetContext } from "../../../../helpers/hooks/useWidgetContext";
import sampleWidgetsList from "../../utils/sampleWidgetsList";
import UndefinedWidget from "../sampleWidgets/undefinedWidget";
const AnalyticsSampleWidgetsFactory = () => {
  const widget = useWidgetContext();
  const WidgetComponent = sampleWidgetsList.find(
    (sampleWidget) => sampleWidget.type === widget.widgetType
  )?.component;
  if (!WidgetComponent) {
    return <UndefinedWidget />;
  }
  return <WidgetComponent />;
};

export default AnalyticsSampleWidgetsFactory;
